'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useRef, useEffect } from 'react';
import Button from '../Button/index.js';
import HeartFillIcon from './Images/HeartFillIcon.js';
import HeartIcon from './Images/HeartIcon.js';
import { Container, Wrapper, Popup } from './PreviewJob.css.js';
import { ELanguage } from '../Utils/constants.js';
import { SUCCESS_CODE } from './constant.js';
import { apiUnsavedJob, apiSaveJob } from './services.js';
import ReactDOM from 'react-dom';
import translation from './translation.js';
import { showToast } from '../Toast/index.js';
import { Widget, JobInvitationBlock } from '../JobCard/JobCard.css.js';
import useHog from '../PostHog/hooks/useHog/index.js';
import '../UploadResumeModal/type.js';
import { EJobInvitationStatus } from '../ApplyJobs/types.js';
import MailAddIcon from '../Images/MailAddIcon/index.js';

var isWindow = typeof window !== 'undefined';
var PreviewJob = function (props) {
    var children = props.children, content = props.content, langCode = props.langCode, onSaveClick = props.onSaveClick, onApplyClick = props.onApplyClick, classContainer = props.classContainer, api = props.api, isLogin = props.isLogin, _a = props.isNLDPage, isNLDPage = _a === void 0 ? false : _a;
    var debounceTimeShow = useState(500)[0];
    var debounceTimeHide = useState(200)[0];
    var debounceShow = useRef(null);
    var debounceHide = useRef(null);
    var eventInfo = useRef(null);
    var _b = useState(!!content.isSaved), isSaved = _b[0], setSaved = _b[1];
    var _c = useState(false), showPopup = _c[0], setShowPopup = _c[1];
    var _d = useState({
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
    }), positionPopup = _d[0], setPositionPopup = _d[1];
    var tracking = useHog().tracking;
    var containerRef = useRef(null);
    var popupRef = useRef(null);
    var isSavedStatus = (api === null || api === void 0 ? void 0 : api.disableSelfApi) ? !!content.isSaved : isSaved;
    var maxBodyHeight = isWindow ? window.screen.height / 5 : 280;
    var t = function (key) {
        if (langCode === ELanguage.VI) {
            return translation[key] || key;
        }
        else {
            return key;
        }
    };
    var showLoginModal = function () {
        if (!isWindow) {
            return;
        }
        setShowPopup(false);
        var loginEvent = new CustomEvent('LOGIN_POPUP', {
            detail: {
                langCode: langCode === ELanguage.VI ? 'vi' : 'en'
            }
        });
        window.dispatchEvent(loginEvent);
    };
    var handleUnsavedJob = function () { return __awaiter(void 0, void 0, void 0, function () {
        var responseResult;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!isLogin) {
                        showLoginModal();
                        return [2 /*return*/];
                    }
                    if (api === null || api === void 0 ? void 0 : api.disableSelfApi) {
                        onSaveClick && onSaveClick();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, apiUnsavedJob({
                            postData: { jobId: content.jobId || -1 },
                            accessToken: (api === null || api === void 0 ? void 0 : api.accessToken) || '',
                            language: langCode,
                            baseUrl: (api === null || api === void 0 ? void 0 : api.baseUrl) || ''
                        })];
                case 1:
                    responseResult = _b.sent();
                    if (((_a = responseResult === null || responseResult === void 0 ? void 0 : responseResult.meta) === null || _a === void 0 ? void 0 : _a.code) === SUCCESS_CODE) {
                        setSaved(false);
                        showToast(t('Success'), t('Just removed 1 save job'));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSaveJob = function () { return __awaiter(void 0, void 0, void 0, function () {
        var saveJobResponse;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!isLogin) {
                        showLoginModal();
                        return [2 /*return*/];
                    }
                    if (api === null || api === void 0 ? void 0 : api.disableSelfApi) {
                        onSaveClick && onSaveClick();
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, apiSaveJob({
                            postData: { jobId: content.jobId || -1 },
                            accessToken: (api === null || api === void 0 ? void 0 : api.accessToken) || '',
                            language: langCode,
                            baseUrl: (api === null || api === void 0 ? void 0 : api.baseUrl) || ''
                        })];
                case 1:
                    saveJobResponse = _c.sent();
                    if (((_a = saveJobResponse === null || saveJobResponse === void 0 ? void 0 : saveJobResponse.meta) === null || _a === void 0 ? void 0 : _a.code) === SUCCESS_CODE) {
                        tracking({
                            eventName: 'js_job_management:save_job_click',
                            properties: {
                                jobId: (_b = content === null || content === void 0 ? void 0 : content.jobId) !== null && _b !== void 0 ? _b : -1,
                                pageZone: 'preview'
                            }
                        });
                        setSaved(true);
                        showToast(t('Success'), React__default.createElement("div", null,
                            t('You have saved job, view'),
                            ' ',
                            React__default.createElement("a", { href: t('/my-career-center/my-jobs?section=saved') }, t('My jobs'))));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleApplyClick = function () {
        if (isNLDPage) {
            window.location.assign(content.link);
            return;
        }
        if (!isLogin) {
            showLoginModal();
            return;
        }
        if (content.redirectTo) {
            window.location.assign(content.redirectTo);
            return;
        }
        onApplyClick();
        setShowPopup(false);
    };
    var debounceShowPopup = function (e) {
        if (debounceHide.current)
            clearTimeout(debounceHide.current);
        debounceShow.current = setTimeout(function () {
            eventInfo.current = e;
            setShowPopup(true);
        }, debounceTimeShow);
    };
    var debounceHidePopup = function () {
        if (debounceShow.current)
            clearTimeout(debounceShow.current);
        debounceHide.current = setTimeout(function () {
            eventInfo.current = null;
            setShowPopup(false);
        }, debounceTimeHide);
    };
    useEffect(function () {
        setSaved(content.isSaved);
    }, [content.isSaved]);
    useEffect(function () {
        var _a, _b;
        (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('mouseenter', function (e) { return debounceShowPopup(e); });
        (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('mouseleave', debounceHidePopup);
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (showPopup && eventInfo.current && popupRef.current) {
            (_a = popupRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('mouseenter', function (e) { return debounceShowPopup(e); });
            (_b = popupRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('mouseleave', debounceHidePopup);
            var e = eventInfo.current;
            var position = {
                left: 0,
                top: 0,
                bottom: 0,
                right: 0
            };
            if (e.clientY > window.innerHeight / 2) {
                position.top = e.pageY - ((_c = popupRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight);
            }
            else {
                position.top = e.pageY;
            }
            if (e.clientX > window.innerWidth / 2) {
                position.left = e.pageX - ((_d = popupRef.current) === null || _d === void 0 ? void 0 : _d.offsetWidth) - 20;
            }
            else {
                position.left = e.pageX + 20;
            }
            setPositionPopup(position);
            popupRef.current.style.opacity = '1';
        }
    }, [showPopup]);
    var renderPopup = function () {
        var _a, _b, _c, _d, _e;
        var bodyNode = typeof document !== 'undefined' && (document === null || document === void 0 ? void 0 : document.querySelector('body'));
        if (bodyNode) {
            return ReactDOM.createPortal(React__default.createElement(Popup.Container, { ref: popupRef, left: positionPopup.left, top: positionPopup.top, bottom: positionPopup.bottom, right: positionPopup.right },
                content.isApplied && React__default.createElement(Widget.AppliedBadge, { isPreviewJob: true }, t('Applied')),
                React__default.createElement(Popup.Wrapper, null,
                    React__default.createElement(Popup.Header, null,
                        React__default.createElement(Popup.Logo, null,
                            React__default.createElement("img", { src: content.logo || 'https://images.vietnamworks.com/img/company-default-logo.svg', alt: 'logo' })),
                        React__default.createElement(Popup.Content, null,
                            React__default.createElement("a", { href: content.link, target: '_blank', onClick: function () { return setShowPopup(false); } },
                                React__default.createElement(Popup.Title, null, content.title)),
                            React__default.createElement("p", null,
                                React__default.createElement("span", null, content.salary),
                                content.jobLevel && " | ".concat(content.jobLevel)),
                            React__default.createElement("p", { className: 'address' }, content.address))),
                    React__default.createElement(Popup.Body, null,
                        React__default.createElement(Popup.BodyContent, { style: { maxHeight: maxBodyHeight } },
                            content.jobDescription && (React__default.createElement(React__default.Fragment, null,
                                React__default.createElement("p", null,
                                    t('Job Description'),
                                    ":"),
                                React__default.createElement("div", { dangerouslySetInnerHTML: {
                                        __html: content.jobDescription.replace(/\r\n/g, '<br />') || ''
                                    } }))),
                            content.jobRequirements && (React__default.createElement(React__default.Fragment, null,
                                React__default.createElement("p", { style: { marginTop: 8 } },
                                    t('Job Requirements'),
                                    ":"),
                                React__default.createElement("div", { dangerouslySetInnerHTML: {
                                        __html: ((_a = content.jobRequirements) === null || _a === void 0 ? void 0 : _a.replace(/\r\n/g, '<br />')) || ''
                                    } })))),
                        content.link && (React__default.createElement(Popup.BodyViewDetail, null,
                            React__default.createElement("a", { href: content.link, target: '_blank' },
                                React__default.createElement("p", { style: { margin: '6px 0 0 0' } }, t('View detail')))))),
                    props.content.jobInvitation &&
                        ((_b = props.content) === null || _b === void 0 ? void 0 : _b.jobInvitation.jobInvitationId) > 0 &&
                        ((_c = props.content) === null || _c === void 0 ? void 0 : _c.jobInvitation.status) === EJobInvitationStatus.WAITING ? (React__default.createElement(Popup.JobInvitation, null,
                        React__default.createElement(JobInvitationBlock, null,
                            React__default.createElement(MailAddIcon, null),
                            React__default.createElement("span", null, t('Employer has sent you an invitation.'))))) : null,
                    React__default.createElement(Popup.Footer, { isApplied: content.isApplied },
                        !content.isApplied && !isNLDPage && (React__default.createElement(Popup.SaveButton, { onClick: isSavedStatus ? handleUnsavedJob : handleSaveJob },
                            React__default.createElement(Popup.IconButton, { show: true },
                                React__default.createElement(HeartIcon, null)),
                            React__default.createElement(Popup.IconButton, { show: !!isSavedStatus },
                                React__default.createElement(HeartFillIcon, null)))),
                        !content.isApplied && (React__default.createElement(Button, { className: 'apply-btn', type: 'primary', style: { flex: 1, cursor: 'pointer' }, disabled: content.isBlackList, onClick: handleApplyClick }, props.content.jobInvitation &&
                            ((_d = props.content) === null || _d === void 0 ? void 0 : _d.jobInvitation.jobInvitationId) > 0 &&
                            ((_e = props.content) === null || _e === void 0 ? void 0 : _e.jobInvitation.status) === EJobInvitationStatus.WAITING
                            ? t('Accept invitation')
                            : t('Apply Now')))))), bodyNode);
        }
        else {
            return null;
        }
    };
    return (React__default.createElement(Container, { "data-cname": 'preview-job', ref: containerRef, className: classContainer },
        React__default.createElement(Wrapper, { onClick: function () { return setShowPopup(false); } }, children),
        showPopup && renderPopup()));
};

export { PreviewJob as default };
//# sourceMappingURL=index.js.map
